<script>
export default {
  functional: true,
  name: "testcom",
  render(h, {data, props, children}) {
    const dts = data.attrs.content
    return h(
        dts,
        {
          ...data,
          props: {
            ...props,
          },
        },
        children
    )
  }
}
</script>
